import BookResults from './BookResults';

export default BookResults;
